import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Tenant, TenantSearchParams} from '@association/_common/models/tenant.models';

export const CheckState = createAction(
    '[Tenants] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: Tenant[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Tenants] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: Tenant[] } }>()
);

export const LoadList = createAction(
    '[Tenants] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Tenants] Load List Success',
    props<{ payload: { items: Tenant[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Tenants] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Tenants] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Tenants] Set Filter',
    props<{ payload: TenantSearchParams }>()
);

export const SetLoading = createAction(
    '[Tenants] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Tenants] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const AddItemSuccess = createAction(
    '[Tenants] Add Item Success',
    props<{ payload: Tenant }>()
);

export const UpdateItemSuccess = createAction(
    '[Tenants] Update Item Success',
    props<{ payload: Tenant }>()
);

export const DeleteItem = createAction(
    '[Tenants] Delete Item',
    props<{ payload: Tenant }>()
);

export const DeleteItemSuccess = createAction(
    '[Tenants] Delete Item Success',
    props<{ payload: Tenant }>()
);

export const DeleteItemFailure = createAction(
    '[Tenants] Delete Item Failure',
    props<{ payload: Tenant }>()
);

export const SetInitialState = createAction(
    '[Tenants] Set Initial State'
);
